/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import IResolucionesFacturaciones from 'Infotrack@Modelos/smartStock/resolucionesFacturaciones/entidades/resolucionesFacturaciones';
import React from 'react';
import ResolucionesFacturacionesCM from '../controladorModelo/resolucionesFacturacionesCM';
import { acciones, IEstadoResolucionesFacturaciones } from '../reductorResolucionesFacturaciones';
import ResolucionesFacturacionesVista from '../vista/tablaResolucionesFacturacionesVista';

const resolucionesFacturacionesCM = new ResolucionesFacturacionesCM();

const TableResolucionesFacturacionesCV: React.FunctionComponent = () => {
    const cargaInicial = React.useRef(true);
    const [resolucionesFacturacioness, setResolucionesFacturacioness] = React.useState<IResolucionesFacturaciones[]>(
        []
    );
    const [{ recargarTabla }, dispatch] = useProveedor<IEstadoResolucionesFacturaciones>();

    React.useEffect(() => {
        if (recargarTabla || cargaInicial.current) {
            cargarResolucionesFacturaciones();
            if (recargarTabla) {
                dispatch({ type: acciones.RECARGAR_TABLA });
            }
        }
        cargaInicial.current = false;
    });

    const cargarResolucionesFacturaciones = () => {
        manejadorIndicadorCargaGlobal(true);
        resolucionesFacturacionesCM.consultarResolucionesFacturaciones().then((resolucionesFacturacioness) => {
            setResolucionesFacturacioness(resolucionesFacturacioness);
            manejadorIndicadorCargaGlobal(false);
        });
    };
    const manejarFormulario = (
        tipoFormulario: TipoFormulario,
        entidadResolucionesFacturaciones?: IResolucionesFacturaciones
    ) => {
        dispatch({
            type: acciones.CAMBIAR_ESTADO_FORMULARIO,
            payload: { entidadResolucionesFacturaciones, tipoFormulario },
        });
    };

    const confirmarEliminacion = (resolucionesFacturaciones: IResolucionesFacturaciones) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => eliminarResolucionesFacturaciones(resolucionesFacturaciones),
            estado: true,
            mensaje: <Texto id={'alerta.confirmacionEliminacion'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };

    const eliminarResolucionesFacturaciones = (resolucionesFacturaciones: IResolucionesFacturaciones) => {
        manejadorIndicadorCargaGlobal(true);
        manejadorDialogoGlobal({ estado: false });
        resolucionesFacturacionesCM.eliminarResolucionesFacturaciones(resolucionesFacturaciones).then(() => {
            manejadorIndicadorCargaGlobal(false);
            dispatch({ type: acciones.RECARGAR_TABLA });
        });
    };

    return (
        <ResolucionesFacturacionesVista
            resolucionesFacturacioness={resolucionesFacturacioness}
            cargarResolucionesFacturaciones={cargarResolucionesFacturaciones}
            confirmarEliminacion={confirmarEliminacion}
            manejarFormulario={manejarFormulario}
        />
    );
};

export default TableResolucionesFacturacionesCV;
